import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import {
  type VariableInfo,
  type WorkflowVariableDefinitionInfo,
} from '@blaze-shared/api-contracts-domain';

interface VariablesState {
  varInfos: VariableInfo[];
  varDefs: WorkflowVariableDefinitionInfo[];
}

const initialState: VariablesState = {
  varInfos: [],
  varDefs: [],
};

export type VariablesStore = InstanceType<typeof VariablesStore>;

export const VariablesStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    addVarDef(varDef: WorkflowVariableDefinitionInfo): void {
      const varDefs = [...store.varDefs(), varDef];
      patchState(store, { varDefs });
    },

    deleteVarDef(id: string): void {
      let varDefs = store.varDefs();
      varDefs = varDefs.filter((def) => def.id !== id);
      patchState(store, { varDefs });
    },

    updateVarDef(updatedVarDef: WorkflowVariableDefinitionInfo): void {
      let varDefs = store.varDefs();
      varDefs = varDefs.map((def) => (def.id === updatedVarDef.id ? updatedVarDef : def));
      patchState(store, { varDefs });
    },

    setVarInfos(varInfos: VariableInfo[]): void {
      patchState(store, { varInfos });
    },

    setVarDefs(varDefs: WorkflowVariableDefinitionInfo[]): void {
      patchState(store, { varDefs });
    },
  })),
);
